import {Box, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import DaumPostcode, {Address} from "react-daum-postcode";
import {dialogClose} from "@/modules/MuiDialog";

type SearchAddressDialogProps = {
    onComplete?: (data?:Address) => void,
}
const SearchAddressDialog = ({onComplete}:SearchAddressDialogProps) => {
    return (
        <>
            {/*<DialogTitle>Dialog Title</DialogTitle>*/}
            <Box>
                <div>
                    <DaumPostcode autoClose={false}
                                  onComplete={(data) => {
                                      if (!!onComplete) onComplete(data);
                                      dialogClose();
                                  }}
                                  defaultQuery={''}
                                  style={{minHeight: 450, backgroundColor:'red', borderRadius: 6, overflow: 'hidden'}} />
                </div>
            </Box>
            {/*<DialogActions></DialogActions>*/}
        </>
    )
}

export default SearchAddressDialog;